import { render, staticRenderFns } from "./TipoLocacion.vue?vue&type=template&id=ecfddce0&"
import script from "./TipoLocacion.vue?vue&type=script&lang=js&"
export * from "./TipoLocacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports